import React from 'react'
import PropTypes from 'prop-types'
import {Chip} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const MultiValue = React.memo(({classes, ...props}) => {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classes.demographicChip}
      color="primary"
      onDelete={props.removeProps.onClick}
      deleteIcon={<CloseIcon className={classes.deleteIcon} {...props.removeProps} />}
    />
  )
})

MultiValue.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  removeProps: PropTypes.object,
}

export default MultiValue
